<template>
	<div class="basicknowledge">
		<headerview :cur="1"></headerview>
		
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					<tipcon v-show="type == 0" :title="'队章'" :name="'队章'" :imgtype="'2'" width="1.31"></tipcon>
					<tipcon v-show="type == 1" :title="'队旗'" :name="'队旗'" :imgtype="'2'" width="1.31"></tipcon>
					<tipcon v-show="type == 2" :title="'队徽'" :name="'队徽'" :imgtype="'2'" width="1.31"></tipcon>
					<tipcon v-show="type == 3" :title="'队歌'" :name="'队歌'" :imgtype="'2'" width="1.31"></tipcon>
				</div>
				
				<!-- <div class="shareto">
					分享至:
					<img class="imgwx" src="../../../static/img/wechat@2x.png" alt=""/>
					<img class="imgqq" src="../../../static/img/qq@2x.png" alt="" @click="qqshare"/>
				</div> -->
				
				<div class="title">
					<span v-show="type == 0">队章</span>
					<span v-show="type == 1">队旗</span>
					<span v-show="type == 2">队徽</span>
					<span v-show="type == 3">队歌</span>			
				</div>		
				<div class="timesource">
					{{informdata.putTime || ''}}
					<span style="margin-left: 0.2rem;">来源: {{informdata.source || ''}}</span>
				</div>
				<div class="line"></div>
				
				<div class="msg" v-html="informdata.content"></div>
				
			</div>	
		</div>
		
		<footview></footview>
		
	</div>
	
</template>

<script>

import tipcon from "../../../com/tipcon.vue";
export default {
  components: {
  	  tipcon,
  },
  data: function() {
    return {
		 type:'0',
	     informdata:{},
	  
    };
  },
  
  watch: {
  	  '$route' (to, from) { //监听路由是否变化
  		  if(to.query.type != from.query.type){
  			  this.type = to.query.type;
  			  this.getTeamBasic();//重新加载数据
  		  }
  	  }
  },

  mounted() {
	    this.$onScrollT()
		
		if(this.$route.query) {
			this.type = this.$route.query.type;
			this.getTeamBasic()
		}
  },
  
  methods: {
		getTeamBasic(){
			this.$get(`web/teamBasic/list?type=${this.type}`).then(res=>{
				  if(res.success){
						this.informdata	= res.result
				  }
			})
			
		},
		
		qqshare(){
			// window.open('http://connect.qq.com/widget/shareqq/index.html?url='
			// +document.location.href+'?sharesource=qzone&title=少先队&pics=图片地址&summary=描述')
			// + '&source=少先队&title=少先队&desc=描述'
			window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(document.location.href));
			  
		},
		
		
		
  },
  
 
  
};
</script>

<style scoped="scoped" lang="scss">
	
.basicknowledge{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			min-height: 1000px;
			padding: 40px;
			box-sizing: border-box;
			.tipcon{
				
			}
			.shareto{
				height: 50px;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				.imgwx{
					cursor: pointer;
					margin-left: 20px;
					height: 22px;
					width: 26px;
				}
				.imgqq{
					cursor: pointer;
					margin-left:20px;
					height:22px;
					width:18px;
				}
			}
			.title{
				font-size:30px;
				font-weight: bold;
				color: #333333;
				text-align: center;
				margin-top:40px;
				height: 50px;
				line-height: 50px;
			}
			.timesource{
				font-size:16px;
				color: #666666;
				text-align: center;
				height: 30px;
				line-height:30px;
			}
			.line{
				width: 100%;
				height: 1px;
				background-color: #ededed;
			}
			
			.msg{
				padding: 40px;
				box-sizing: border-box;
			}
			
		}
			
	}		
	
	
}

</style>
<style scoped>
/deep/ .msg img{
	max-width: 100%;
	vertical-align: middle
}
</style>